import { lazy } from 'react';

import type { AppRouteConfig } from '@/App/AppRoutes/types';

const RegisterCompletePage = lazy(() =>
  import('@/components/pages/RegisterCompletePage').then(({ RegisterCompletePage }) => ({
    default: RegisterCompletePage,
  })),
);

export const RegisterCompleteRoute: AppRouteConfig = {
  key: 'register-complete-page',
  path: '/register_complete/:locale?',
  component: RegisterCompletePage,
};
